import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../../actions/actions";
import { PlanoContaResultadoModel } from "../../../models/planoContaResultado/planoContaResultadoModel";
import {  listarIndicadorCalculoResultado, listarPlanoContaResultado } from "../../../services/planoContaResultadoService";
import { BuscaPlanoContaResultadoModel } from "../../../models/planoContaResultado/buscaPlanoContaResultadoModel";
import { IndicadoresModel } from "../../../models/planoContaResultado/indicadoresModel";

export interface PlanoContaResultadoState {
  //buscar plano conta resultado
  loading: boolean;
  busca: BuscaPlanoContaResultadoModel;
  list: PlanoContaResultadoModel[];
  //buscar indicador calculo resultado
  loadingIndicadores: boolean;
  listIndicadores: IndicadoresModel[];
}

const initialState: PlanoContaResultadoState = {
  //buscar plano conta resultado
  loading: false,
  busca: {
    codigoIndicador: "DESP_FIN_ENTIDADE",
    pesquisar: null,
    ativo: true,
    associado: true,
  } as BuscaPlanoContaResultadoModel,
  list: [],
  //buscar indicador calculo resultado
  loadingIndicadores: false,
  listIndicadores: [],
};

export const planoContaResultadoSlice = createSlice({
  name: "planoContaResultado",
  initialState,
  reducers: {
    //buscar plano conta resultado
    setBuscaPlanoContaResultado: (state, action) => {
      state.busca = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar plano conta resultado
    builder.addCase(listarPlanoContaResultado.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarPlanoContaResultado.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarPlanoContaResultado.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar indicador calculo resultado
    builder.addCase(listarIndicadorCalculoResultado.pending, (state) => {
      state.loadingIndicadores = true;
    });
    builder.addCase(listarIndicadorCalculoResultado.fulfilled, (state, action) => {
      state.listIndicadores = action.payload;
      state.loadingIndicadores = false;
    });
    builder.addCase(listarIndicadorCalculoResultado.rejected, (state, action) => {
      state.loadingIndicadores = false;
    });
  },
});

export const {
  //buscar plano conta resultado
  setBuscaPlanoContaResultado,
} = planoContaResultadoSlice.actions;

export default planoContaResultadoSlice.reducer;
